// extracted by mini-css-extract-plugin
export default {"container":"about_container__V0MZM","aboutImg":"about_aboutImg__PmPqt","mainContainer":"about_mainContainer__RgUon"};